import { getConfig } from '@leagueplatform/config';

export const getScopedLegacyCssClassNames = () => {
  const { config } = getConfig();

  // eslint-disable-next-line no-underscore-dangle
  const shouldApplyCSSReset = config?.__internal?.shouldApplyCSSReset;

  const shouldApplyLegacyGlobalStyles =
    // eslint-disable-next-line no-underscore-dangle
    config?.__internal?.shouldApplyLegacyGlobalStyles;

  if (shouldApplyCSSReset && shouldApplyLegacyGlobalStyles) {
    return '';
  }

  const classNames = [];
  if (!shouldApplyCSSReset) classNames.push('league-css-reset');
  if (!shouldApplyLegacyGlobalStyles)
    classNames.push('league-legacy-global-styles');

  return classNames.join(' ');
};
